import React, { useEffect, useState } from 'react';
import { Form, Input, Popconfirm, Table, Tooltip, Typography } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
const EditableCell = ({ editing, dataIndex, title, inputType, record, index, children, ...restProps }) => {
    return (React.createElement("td", { ...restProps }, editing ? (React.createElement(Form.Item, { name: dataIndex, style: { margin: 0 }, rules: [
            {
                required: true,
                message: `Please enter ${title.toLowerCase()}!`,
            },
        ] },
        React.createElement(Input, { style: { width: '100%' } }))) : (children)));
};
/**
 * Generic table to display, edit and delete data
 *
 * @param
 * @returns
 */
export const EditableTable = ({ tableData, tableColumns, addEditColumn, onSave, onDelete, }) => {
    const [form] = Form.useForm();
    const [data, setData] = useState(tableData);
    const [editingKey, setEditingKey] = useState('');
    useEffect(() => {
        setData(tableData);
    }, [tableData]);
    const isEditing = (record) => record.id === editingKey;
    const edit = (record) => {
        form.setFieldsValue({ ...record });
        setEditingKey(record.id);
    };
    const cancel = () => {
        setEditingKey('');
    };
    const save = async (key) => {
        try {
            const row = (await form.validateFields());
            const newData = [...data];
            const index = newData.findIndex((item) => key === item.id);
            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, {
                    ...item,
                    ...row,
                });
                const fieldsToUpdate = {
                    ...item,
                    ...row,
                };
                delete fieldsToUpdate.id;
                onSave(item.id, fieldsToUpdate);
                setData(newData);
                setEditingKey('');
            }
            else {
                newData.push(row);
                setData(newData);
                setEditingKey('');
            }
        }
        catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    };
    const handleDelete = (id) => {
        const newData = data.filter((item) => item.id !== id);
        onDelete(id);
        setData(newData);
    };
    const nonOperationColumns = tableColumns.filter((col) => col.title !== 'operation');
    if (addEditColumn) {
        nonOperationColumns.push({
            title: '',
            dataIndex: 'operation',
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (React.createElement("span", null,
                    React.createElement(Typography.Link, { onClick: () => save(record.id), style: { marginInlineEnd: 8, color: 'blue' } }, "Save"))) : (React.createElement("div", { className: "flex-row", style: { gap: 8 } },
                    React.createElement(Typography.Link, { disabled: editingKey !== '', onClick: () => edit(record), style: { color: 'blue' } },
                        React.createElement(Tooltip, { className: "clickable", title: "Edit" },
                            React.createElement(EditOutlined, null))),
                    React.createElement(Popconfirm, { className: "clickable", title: "Sure to delete?", onConfirm: () => handleDelete(record.id) },
                        React.createElement(Tooltip, { className: "clickable", title: "Delete" },
                            React.createElement(DeleteOutlined, { style: { color: 'red' } })))));
            },
        });
    }
    const mergedColumns = nonOperationColumns.map((col) => {
        if (!('editable' in col) || !col.editable) {
            return col;
        }
        return {
            ...col,
            //   width: 120,
            onCell: (record) => {
                // Type narrow the column to ensure `dataIndex` exists
                if ('dataIndex' in col) {
                    return {
                        record,
                        inputType: 'text',
                        dataIndex: col.dataIndex,
                        title: col.title,
                        editing: isEditing(record),
                    };
                }
                return {};
            },
        };
    });
    return (React.createElement(Form, { form: form, component: false },
        React.createElement(Table, { components: {
                body: { cell: EditableCell },
            }, bordered: true, dataSource: data, columns: mergedColumns, pagination: { onChange: cancel } })));
};
export default EditableTable;
